import { Injectable } from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDrawer} from "@angular/material/sidenav";
import {BehaviorSubject} from "rxjs";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmDialogComponent, ConfirmDialogData} from "../components/dialogs/confirm-dialog/confirm-dialog.component";
import {QrDialogComponent, QrDialogData} from "../components/dialogs/qr-dialog/qr-dialog.component";
import {InfoDialogComponent, InfoDialogData} from "../components/dialogs/info-dialog/info-dialog.component";
import {EditDialogComponent, EditDialogData} from "../components/dialogs/edit-dialog/edit-dialog.component";
import {InputDialogComponent, InputDialogData} from "../components/dialogs/input-dialog/input-dialog.component";

@Injectable({
  providedIn: 'root'
})
export class UiManagerService {

  public static colors = [
    '#0e50ab',
    '#0c49a4',
    '#0a409a',
    '#083791',
    '#042780'
  ];

  private sidebar = new BehaviorSubject<MatDrawer>(null);

  constructor(
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) { }

  notify(message: string, action: string = '') {
    this.snackBar.open(message, action, {
      duration: 2000,
      /*horizontalPosition: "right",
      verticalPosition: "top",*/
    });
  }

  setSidebar(sidebar: MatDrawer) {
    this.sidebar.next(sidebar);
    this.sidebar.complete();
  }

  async showSidebar() {
    if (this.sidebar.value) {
      await this.sidebar.value.open();
    } else {
      // Execute as soon as sidebar is set
      (await this.sidebar.toPromise()).open();
    }
  }

  async hideSidebar() {
    if (this.sidebar.value) {
      await this.sidebar.value.close();
    } else {
      // Execute as soon as sidebar is set
      (await this.sidebar.toPromise()).close();
    }
  }

  showConfirmDialog(title: string, description: string, onSuccess: Function, onCancel?: Function) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: { title, description } as ConfirmDialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        onSuccess();
      } else if(onCancel) {
        onCancel();
      }
    });
  }

  showConfirmDialogWithExtraTags(title: string, description: string, onSuccess: (tags?: string[]) => void, onCancel?: Function) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: { title, description, withExtraTags: true } as ConfirmDialogData
    });

    dialogRef.afterClosed().subscribe((result: ConfirmDialogData) => {
      if (result) {
        onSuccess(result.extraTags);
      } else if(onCancel) {
        onCancel();
      }
    });
  }

  showInfoDialog(title: string, description: string) {
    this.dialog.open(InfoDialogComponent, {
      width: '500px',
      data: { title, description } as InfoDialogData
    });
  }

  showInputDialog(title: string, confirmBtnLabel: string, data?: Partial<InputDialogData>, onSuccess?: (data) => void) {
    const dialogRef = this.dialog.open(InputDialogComponent, {
      width: '500px',
      data: { title, confirmBtnLabel, input: data?.input } as InputDialogData
    });

    dialogRef.afterClosed().subscribe((result: InputDialogData) => {
      if (result) {
        onSuccess(result)
      }
    });
  }

  showQRCode(qrContent: QrDialogData) {
    this.dialog.open(QrDialogComponent, {
      width: '512px',
      data: qrContent
    });
  }

  showTextInputDialog(title: string, label: string, onSuccess: Function, onCancel?: Function) {
    const dialogRef = this.dialog.open(EditDialogComponent, {
      width: '400px',
      data: { title, label } as EditDialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        onSuccess(result);
      } else if(onCancel) {
        onCancel();
      }
    });
  }

}
